var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMailIconActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.999,
    height: 17.995,
    viewBox: "0 0 23.999 17.995",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3598",
    "data-name": "Group 3598",
    transform: "translate(-230 -98)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3435",
    "data-name": "Path 3435",
    d: "M20.115,21H3.884A3.9,3.9,0,0,1,0,17.118V7.627A.5.5,0,0,1,.758,7.2l9.171,5.549a4,4,0,0,0,4.141,0L23.241,7.2A.5.5,0,0,1,24,7.627v9.491A3.9,3.9,0,0,1,20.115,21",
    transform: "translate(230 94.993)",
    fill: "#E65847"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3436",
    "data-name": "Path 3436",
    d: "M13.143,8.545l6.641-4.627a.5.5,0,0,0-.286-.911H4.5a.5.5,0,0,0-.286.911l6.642,4.627a2,2,0,0,0,2.286,0",
    transform: "translate(230 94.993)",
    fill: "#E65847"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIconActive);
export default __webpack_public_path__ + "static/media/MailIconActive.bcba37f442d09d23d6c36d0fad4b096d.svg";
export { ForwardRef as ReactComponent };